/**
 * CVR Cart Pump-up
 * 送料無料ラインまであと少しのカートに、少額商品を1タップで足す導線。
 * markup は snippets/cvr-cart-pumpup.liquid (cvr-cart-trust 経由でドロワー / カートページ両方に出る)。
 *
 * サーバ側で描画済みの状態を正とするが、カート更新後にコンテナが再描画されない経路が
 * あるため、cartUpdate を受けたら /cart.js から引き直して自前で出し入れする。
 */
(function () {
  'use strict';

  if (window.__cvrCartPumpupBound) return;
  window.__cvrCartPumpupBound = true;

  var SELECTOR = '[data-cvr-pumpup]';

  /** global.js の PUB_SUB_EVENTS は const 宣言なので window には生えない */
  function events() {
    if (!window.FoxThemeEvents) return null;
    if (typeof PUB_SUB_EVENTS === 'undefined') return null;
    return { bus: window.FoxThemeEvents, names: PUB_SUB_EVENTS };
  }

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  /** 残額を埋めるのに必要な個数。射程(max_units 個ぶん)を超えていれば 0 */
  function unitsNeeded(remaining, unit, maxUnits) {
    if (remaining <= 0 || unit <= 0) return 0;
    var qty = Math.ceil(remaining / unit);
    return qty > maxUnits ? 0 : qty;
  }

  function paint(card, qty) {
    if (qty <= 0) {
      card.hidden = true;
      return;
    }
    var lead = card.querySelector('[data-cvr-pumpup-lead]');
    var price = card.querySelector('[data-cvr-pumpup-price]');
    var btn = card.querySelector('[data-cvr-pumpup-add]');

    if (lead) lead.textContent = 'こちら' + qty + '点で送料無料になります';
    if (price) price.textContent = (card.dataset.unitMoney || '') + 'x' + qty + '点';
    if (btn) btn.dataset.qty = String(qty);

    card.hidden = false;
  }

  function sync() {
    var list = cards();
    if (list.length === 0) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        list.forEach(function (card) {
          var unit = parseInt(card.dataset.unit, 10) || 0;
          var limit = parseInt(card.dataset.limit, 10) || 0;
          var maxUnits = parseInt(card.dataset.maxUnits, 10) || 1;

          if (cart.item_count === 0 || limit <= 0) {
            card.hidden = true;
            return;
          }
          var remaining = limit - Math.floor(cart.total_price / 100);
          paint(card, unitsNeeded(remaining, unit, maxUnits));
        });
      })
      .catch(function () { /* 表示更新に失敗してもサーバ描画済みの状態を残す */ });
  }

  /** product-form.js と同じ束ね方で、追加後に再描画したいセクションを列挙する */
  function sectionsToBundle() {
    var ids = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: ids } })
    );

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      ids = ids.concat(drawer.getSectionsToRender().map(function (s) { return s.id; }));
    }

    var mainCart = document.querySelector('cart-items');
    if (mainCart && typeof mainCart.getSectionsToRender === 'function') {
      ids = ids.concat(mainCart.getSectionsToRender().map(function (s) { return s.section; }));
    }

    return ids;
  }

  function add(btn) {
    var card = btn.closest(SELECTOR);
    if (!card || btn.disabled) return;

    var variantId = card.dataset.variantId;
    var qty = parseInt(btn.dataset.qty, 10) || 1;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('btn--loading');

    var form = new FormData();
    form.append('id', variantId);
    form.append('quantity', qty);

    var ids = sectionsToBundle();
    if (ids.length) {
      form.append('sections', ids.join(','));
      form.append('sections_url', window.location.pathname);
    }

    var url =
      (window.FoxThemeSettings &&
        window.FoxThemeSettings.routes &&
        window.FoxThemeSettings.routes.cart_add_url) ||
      '/cart/add';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: form
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          // 在庫切れ等。ボタンを戻して黙って引っ込める(カート内の邪魔をしない)
          card.hidden = true;
          return;
        }
        var ev = events();
        if (ev) {
          ev.bus.emit(ev.names.cartUpdate, res);
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        }
        sync();
      })
      .catch(function (e) { console.error('[cvr-pumpup]', e); })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cvr-pumpup-add]');
    if (btn) add(btn);
  });

  function bindCartEvents() {
    var ev = events();
    if (ev) {
      ev.bus.subscribe(ev.names.cartUpdate, function () {
        setTimeout(sync, 0);
      });
    }
    document.addEventListener('cart:refresh', function () { setTimeout(sync, 0); });
  }

  if (document.readyState !== 'loading') bindCartEvents();
  else document.addEventListener('DOMContentLoaded', bindCartEvents);
})();
